import { getFirstWeekWeightLoss } from "../helpers"

export default (getView) =>
  ({ nextStepPath }) => ({
    ...getView({
      nextStepPath,
    }),

    init() {
      this.store = Alpine.store("data")
      this.handleLoadingEnd = this.handleLoadingEnd.bind(this)
      this.commonInit()
    },

    getFirstWeekWeightLoss() {
      return getFirstWeekWeightLoss(this.store.values)
    },

    handleLoadingEnd() {
      setTimeout(() => {
        window.location = nextStepPath
      }, 2000)
    },
  })
